import React from 'react';
import PropTypes from 'prop-types';

export default class FormErrors extends React.Component {
  static propTypes = {
    errors: PropTypes.array
  };

  static defaultProps = {
    errors: []
  };

  render() {
    const errorLabels = this.props.errors.map((error) => this.errorLabel(error));
    const displayType = errorLabels.length > 0 ? "block" : "none";
    return (
      <div style={{ display: displayType, maxHeight: "150px", overflowY: "scroll" }} className="alert alert-danger">
        {errorLabels}
      </div>
    );
  }

  errorLabel(error) {
    return (
      <div key={error} className="form-error">
        {error}
      </div>
    );
  }
}
